import { initAboutSectionCertificates } from "./about-section-certificates/index.js";

function initAboutPageModules() {
    initAboutSectionCertificates();
}

window.onload = () => {
    initAboutPageModules();
};